import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams, Outlet, Link } from "react-router-dom";
import { Menu, ConfigProvider, Dropdown, Space, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { cloneDeep } from "lodash-es";
import api from "@/api";
import { getSuperDeviceTemplateDetail } from "@/utils";
import { publicPath } from "@/utils/base";

import dataJson from "@/../public/data.json";

const prefix = "superDeviceTemplateDetail";
import "./index.less";

function SuperDeviceTemplateDetail() {
  const { super_device_template_detail, req_err } = dataJson;
  const [current, setCurrent] = useState("");
  const [superDeviceTemplateList, setSuperDeviceTemplateList] = useState<any[]>([]);
  const [isTampered, setIsTampered] = useState(false);

  const superDeviceTemplateDetail = useSelector((state: any) => state.superDeviceTemplateDetail);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { id } = useParams();

  const onClick = (e: any) => {
    if (current === e.key) {
      return;
    }
    setCurrent(e.key);
    navigate(`${publicPath}${e.item.props.url}/${superDeviceTemplateDetail?.id || id}`);
  };

  const getSuperDeviceTemplateList = async () => {
    try {
      const res: any = await api.getSuperDeviceNoPage({
        appBelong: superDeviceTemplateDetail?.appBelong,
      });
      if (res.code === 200) {
        const pathnameArr = window.location.pathname.split("/");
        const basePathname = pathnameArr.slice(0, pathnameArr.length - 1).join("/");

        const dataCopy = cloneDeep(res.data);
        const list = dataCopy.map((item: any) => {
          return {
            key: item.id,
            label: <Link to={`${basePathname}/${item.id}`}>{item.name}</Link>,
          };
        });

        setSuperDeviceTemplateList(list || []);
      } else {
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
    }
  };

  useEffect(() => {
    if (superDeviceTemplateDetail) {
      getSuperDeviceTemplateList();
    }
  }, [superDeviceTemplateDetail]);

  useEffect(() => {
    const pathArr = pathname.split("/");
    setCurrent(pathArr[pathArr.length - 2]);
  }, [pathname]);

  useEffect(() => {
    setIsTampered(false);
    getSuperDeviceTemplateDetail(id, undefined, () => {
      setIsTampered(true);
      navigate(-1);
    });
  }, [id]);
  return (
    <div className={prefix}>
      <div className={`${prefix}-menu-wrap`}>
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                itemSelectedBg: "#0A59F7",
                itemSelectedColor: "#fff",
                itemBorderRadius: 0,
                iconSize: 14,
                itemHeight: 64,
                fontSize: 18,
              },
            },
          }}
        >
          <Menu
            onClick={onClick}
            mode="inline"
            items={super_device_template_detail.menu}
            defaultOpenKeys={["distribute"]}
            selectedKeys={[current]}
            className={`${prefix}-menu`}
          />
        </ConfigProvider>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Button: { colorPrimary: "#0A59F7" },
            Tabs: { colorPrimary: "#0A59F7" },
          },
        }}
      >
        <div className={`${prefix}-top`}>
          <div className={`${prefix}-breadCrumb`}>
            <Link to={`${publicPath}/staging`} state={{ tabKey: "2" }} className={`${prefix}-breadCrumb-link`}>
              {super_device_template_detail.detail_title_nav}
            </Link>
            &nbsp;/&nbsp;
            <Link to={`${publicPath}/super_device_template`} className={`${prefix}-breadCrumb-link`}>
              {super_device_template_detail.template_manage_nav}
            </Link>
            &nbsp;/&nbsp;
            <Dropdown menu={{ items: superDeviceTemplateList, style: { maxHeight: "70vh" } }}>
              <Space style={{ color: "#1A1A1A" }}>
                {superDeviceTemplateDetail?.name}
                <DownOutlined />
              </Space>
            </Dropdown>
          </div>
        </div>

        <Outlet context={{ isTampered, setIsTampered }} />
      </ConfigProvider>
    </div>
  );
}

export default SuperDeviceTemplateDetail;
